import { ServiceBasic } from "./core/service.basic";

export class HomeService extends ServiceBasic {

  static getHomeData() {
    return this.http.post('/index/index');
  }

}
